<template>
  <div>
    <sent-summary
      :preview="preview"
      :item="item"
      :loading="loading"
      :cloning="isCloning"
    >
      <sent-summary-header
        v-bind="{ item, loading, action, isLink, isEmbedCode, isWeChat, groups, isCloning}"
        @outreach-activity="goToOutreachActivity"
        @clone="onClone(item.pk)"
        @goToClientDetail="goToClientDetail"
        @show-report="showReport"
        @showLinkModal="showLinkModal"
      />
    </sent-summary>

    <!-- Clients email container -->
    <client-email-events-container
      :outreach-id="item.outreach_pk"
      :show="showOutreachReport"
      :customer="item.shared_to"
      :edit="item"
      @closed="onEventsModalClosed"
    />
    <link-creation-modal
      ref="linkModal"
      :edit="item.pk"
      :display="item.display"
      :prevent-default-close="true"
    />
  </div>
</template>
<script>

import { EventBus } from '@/event-bus';
import {
  TEXT, WECHAT, EMBED, METHODS,
} from '@/components/Widgets/DraftEditor/LinkShareMethodSelector';
import SentSummary from './SentSummary';
import SentSummaryHeader from './SentSummaryHeader';

export default {
  name: 'SentSummaryContainer',
  component: {
    SentSummary,
    SentSummaryHeader,
  },
  props: {
    intro: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      clonedItem: {},
      showOutreachReport: false,
    };
  },
  computed: {
    item() {
      return this.$store.state.entries.summaryItem;
    },
    itemDetails() {
      return this.$store.state.entries.item;
    },
    preview() {
      return this.$store.state.entries.preview;
    },
    loading() {
      return this.$store.state.entries.loading;
    },
    isCloning() {
      return this.$store.state.entries.cloningItems.includes(this.item.pk);
    },
    groups() {
      if (!this.item.to_groups) {
        return [];
      }
      return this.item.to_groups;
    },
    action() {
      return this.item.sent_status === 1 ? 'Delivered'
        : (this.item.display === 'wechat' ? 'WeChat Download Shared'
          : (this.item.display === 'scheduled' ? 'Scheduled' : 'Share Link'));
    },
    isEmbedCode() {
      return this.item.display === 'embed';
    },
    isLink() {
      return this.item.display === 'html' || this.item.display === 'wechat';
    },
    isWeChat() {
      return this.item.display === 'wechat';
    },
  },
  async mounted() {
    await this.$store.dispatch('entries/fetchData', this.$route.params.id);
    const len = this.itemDetails.owner.length; // length of url
    const ownerId = this.itemDetails?.owner?.substring(len - 2, len - 1);
    const userId = this.$store.state.account?.user?.profile?.pk?.toString();

    let showIntro = false;
    if (ownerId === userId && this.intro) {
      showIntro = true;
    }

    const args = { id: this.$route.params.id, intro: showIntro };
    this.$store.dispatch('entries/getSentSummary', this.$route.params.id);
    this.$store.dispatch('entries/getPreview', args);
    EventBus.$on('duplicateReady', this.cloneRedirect);
  },
  methods: {
    onClone(editId) {
      if (this.isCloning) return;
      this.clonedItem = this.$store.dispatch('entries/cloneItem', editId);
    },
    cloneRedirect(clonedItem) {
      this.$router.push(`/entries/${clonedItem.pk}/edit`);
    },
    goToOutreachActivity(groupPk = undefined) {
    /**
      Redirects to outreach activity view.
        group: Number: Filters by group id
        group: 0: Only shows independent customers
        group: undefined: show all recipients
    */
      this.$router.push({ path: `/reports/outreach/${this.item.outreach_pk}/activity/`, query: { group: groupPk } });
    },
    getShareMethod() {
      if (this.item.display === 'wechat') {
        return METHODS[WECHAT];
      }
      if (this.item.display === 'embed') {
        return METHODS[EMBED];
      }
      return METHODS[TEXT];
    },
    showLinkModal() {
      this.$nextTick().then(() => {
        // We are filling the Embed here
        this.$refs.linkModal.link = this.item.link;
        this.$refs.linkModal.selectedShareMethod = this.getShareMethod();
        this.$refs.linkModal.hero = `${this.item.hero}&dpr=2`; // dpr=2 IMGX prop doubles the size (AKA Retina display)
        this.$refs.linkModal.title = this.item.subject;

        if (this.item.display === 'wechat') {
          this.$refs.linkModal.downloadWeChatImage();
        }
        this.$refs.linkModal.showLinkCreatedModal = true;
      });
    },
    goToClientDetail(clientPk) {
      this.$router.push(`/clients/${clientPk}`);
    },
    showReport(pk) {
      // if (this.item.sent_status === 2) {
      // this.showOutreachReport = true;
      // } else {
      this.$router.push(`/reports/outreach/${pk}/stats/`);
      // }
    },
    onEventsModalClosed() {
      this.showOutreachReport = false;
    },
  },
};

</script>
<style lang="css"
  scoped>
</style>
